var exports = {
  "GF": "ReportFlowPreview.module__messageScroller___U3ZoMz",
  "BK": "ReportFlowPreview.module__messageContent___U3ZoMz",
  "Kg": "ReportFlowPreview.module__userCard___U3ZoMz",
  "fz": "ReportFlowPreview.module__userText___U3ZoMz",
  "nT": "ReportFlowPreview.module__userName___U3ZoMz",
  "a1": "ReportFlowPreview.module__userTag___U3ZoMz",
};

module.exports = exports;
